import { FC } from 'react'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'
import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { useFeatureFlag } from '@/hooks/use-feature-flags'
import useTranslate from '@/hooks/use-translate'
import { FeatureNames } from '@/lib/featureFlags'

/** Violet de la maquette TEC-1653 (mode préparation intelligente). */
export const intelligentPreparationViolet = '#7C3AED'

type AgenticPreparationIndicatorProps = {
  labeled?: boolean
}

export const AgenticPreparationIndicator: FC<
  AgenticPreparationIndicatorProps
> = ({ labeled = false }) => {
  const { t } = useTranslate('upload')
  const isSmartPreparationEnabled = useFeatureFlag(
    FeatureNames.smartPreparation
  )
  const title = t('wizardPreparationModeIntelligentTitle')
  const description = t('wizardPreparationModeIntelligentDescription')

  if (!isSmartPreparationEnabled) return null

  return (
    <Tooltip
      title={
        <>
          <Box component="span" sx={{ display: 'block', fontWeight: 600 }}>
            {title}
          </Box>
          {description}
        </>
      }
      placement="top"
    >
      <Box
        component="span"
        role="img"
        aria-label={title}
        data-testid="agentic-preparation-indicator"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.75,
          flexShrink: 0,
          lineHeight: 0,
          color: intelligentPreparationViolet,
        }}
      >
        <AutoAwesomeIcon sx={{ fontSize: 16, color: 'inherit' }} />
        {labeled && (
          <Typography
            component="span"
            variant="subtitle2"
            sx={{ color: 'inherit', lineHeight: 1.2 }}
          >
            {title}
          </Typography>
        )}
      </Box>
    </Tooltip>
  )
}

export default AgenticPreparationIndicator
